const translations = {
  accountHolder: {
    en: "PCHQ BE BB du Centre de perception",
    fr: "PCHQ BE BB du Centre de perception",
    nl: "PCHQ BE BB van het Inningscentrum",
  },
  emailSubject: {
    en: "TOB declaration",
    fr: "Déclaration TOB",
    nl: "TOB aangifte",
  },
  dear: {
    en: "Dear Sir/Madam",
    fr: "Madame, Monsieur",
    nl: "Geachte heer, mevrouw",
  },
  emailIntro: {
    en: "Please find attached the TOB declaration document as well as a copy of the proof of payment of this tax for the month of",
    fr: "Veuillez-trouver, ci-joints, le document de déclaration TOB ainsi qu'une copie de la preuve de paiement de cette taxe pour le mois de",
    nl: "Gelieve in bijlage het document van de TOB-aangifte en een kopie van het betalingsbewijs van deze belasting voor de maand",
  },
  emailIntroContinued: {
    en: "",
    fr: "",
    nl: "te vinden",
  },
  months: {
    1: {
      en: "January",
      fr: "Janvier",
      nl: "Januari",
    },
    2: {
      en: "February",
      fr: "Février",
      nl: "Februari",
    },
    3: {
      en: "March",
      fr: "Mars",
      nl: "Maart",
    },
    4: {
      en: "April",
      fr: "Avril",
      nl: "April",
    },
    5: {
      en: "May",
      fr: "Mai",
      nl: "Mei",
    },
    6: {
      en: "June",
      fr: "Juin",
      nl: "Juni",
    },
    7: {
      en: "July",
      fr: "Juillet",
      nl: "Juli",
    },
    8: {
      en: "August",
      fr: "Août",
      nl: "Augustus",
    },
    9: {
      en: "September",
      fr: "Septembre",
      nl: "September",
    },
    10: {
      en: "October",
      fr: "Octobre",
      nl: "Oktober",
    },
    11: {
      en: "November",
      fr: "Novembre",
      nl: "November",
    },
    12: {
      en: "December",
      fr: "Décembre",
      nl: "December",
    },
  },
  ssn: {
    en: "Social Security Number",
    fr: "Numéro de registre national",
    nl: "Rijksregisternummer",
  },
  name: {
    en: "Name",
    fr: "Nom",
    nl: "Naam",
  },
  address: {
    en: "Address",
    fr: "Adresse",
    nl: "Adres",
  },
  amount: {
    en: "Amount",
    fr: "Montant",
    nl: "Bedrag",
  },
  communication: {
    en: "Wire transfer communication",
    fr: "Référence virement bancaire",
    nl: "Mededeling overschrijving",
  },
  seeAttached: {
    en: "see attached proof of payment",
    fr: "voir preuve de paiement en annexe",
    nl: "zie bijgevoegd betalingsbewijs",
  },
  userQuality: {
    en: "Instructing party",
    fr: "Donneur d'ordre",
    nl: "Ordergever",
  },
};

export default translations;
